<pg-header
  title="Micropockets"
  ticon="database"
  sbtitle="AP OWMS data"
  bckbtn="true"
></pg-header>

@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="mcrptLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="LMO Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblEdtBtn"
              (click)="onCellClick('edit', data)"
            >
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblDelBtn"
              (click)="onCellClick('delete', data)"
            >
              Delete
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="mcrpckMrgn">
      <div class="inptLbl">Micropocket Name</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="mcrptDt.mcrpt_nm"
          placeholder="Enter micropocket name"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">Micropocket Number</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="mcrptDt.mcrpt_nu"
          placeholder="Enter micropocket number"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">ULB</div>
      <input
        placeholder="Select ulb"
        nz-input
        [(ngModel)]="mcrptDt.ulb_nm"
        (ngModelChange)="onChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete #auto>
        @for (d of ulbs; track d) {
        <nz-auto-option [nzValue]="d.ulb_nm" (click)="getULBID(d.ulb_id)"
          >{{ d.ulb_nm }}
        </nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">Ward Number</div>
      <input
        placeholder="Select ward"
        nz-input
        [(ngModel)]="mcrptDt.wrd_nm"
        (ngModelChange)="onWardChange($event)"
        [nzAutocomplete]="wrdauto"
      />
      <nz-autocomplete #wrdauto>
        @for (d of wards; track d) {
        <nz-auto-option [nzValue]="d.wrd_nm" (click)="getWardID(d.wrd_id)"
          >{{ d.wrd_nm }}
        </nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <ng-template #inputClearTpl>
      @if (mcrptDt.mcrpt_nm) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="mcrptDt = {}"
      ></i>
      }
    </ng-template>
    @if (shwMcrptEditDiv==false && shwMcrptDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveMcrpt()">
      Submit
    </button>
    } @if (shwMcrptEditDiv==true && shwMcrptDelDiv==false) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveEditMcrpt()"
    >
      Update
    </button>
    } @if (shwMcrptEditDiv==false && shwMcrptDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this Micropocket?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="saveDeleteMcrpt()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    } @if (shwSidebar) {
    <button nz-button nzType="default" class="cnclBtn" (click)="oncancel()">
      Cancel
    </button>
    }
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
          <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
        </div> -->
  </nz-result>
</div>
}
